module.exports = __webpack_public_path__ + "static/media/parallax-bg-02.374fb398.jpg";